export default __webpack_public_path__ + "static/media/CAMCORP.153c8528.png";